import { createSlice } from "@reduxjs/toolkit";
import { categoryGetLandingPage } from "./categoryAsyncThunk";

const categoryGetLandingPageSlice = createSlice({
  name: "category",
  initialState: {
    payload: [],
    isLoading: false,
    isSuccess: false,
    isFail: false,
  },
  reducers: {},
  extraReducers: {
    [categoryGetLandingPage.pending]: (state, action) => {
      state.isLoading = true;
      state.isSuccess = false;
      state.isFail = false;
    },
    [categoryGetLandingPage.fulfilled]: (state, action) => {
      state.isLoading = false;
      state.isSuccess = true;
      state.payload = [...action.payload.list];
    },
    [categoryGetLandingPage.rejected]: (state, action) => {
      state.isLoading = false;
      state.isFail = true;
    },
  },
});

export default categoryGetLandingPageSlice.reducer;
